module.exports = __webpack_public_path__ + "media/images/result_sets/icons/stress_icon-449d3ebe21e923dadbc28b3707e5b989.svg";